export default __webpack_public_path__ + "static/media/euro.82e25dbd.png";